import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { getCustomer, setRedirectTo, resetVerifiedUser } from '../redux/actions'
import AjaxLoader from '../components/AjaxLoader'
import { useLocation } from 'react-use'

const AuthContainer = (props) => {
    const [inProgress, setInProgress] = useState(true)
    const location = useLocation()

    useEffect(() => {
        if (!props.isLoggedIn && location.trigger !== "replacestate") {
            props.setRedirectTo(location.pathname);
        }
        setRedirectTo()
    }, [])

    const setRedirectTo = () => {
        if (!props.isLoggedIn && window.location.pathname !== '/login' && location.trigger !== 'replacestate') {
            props.setRedirectTo(location.pathname)
        }

        setTimeout(() => setInProgress(false), 500)
    }

    if (props.isLoggedIn && inProgress) {
        return <AjaxLoader />
    }

    // Overwrite to redirect to MFA

    if (props.isLoggedIn && !props.isMfaChecked && window.location.pathname !== '/mfa' && !props.isInternalLogin) {
        return <Redirect to='/mfa' />
    }

    return props.isLoggedIn ? props.children : <Redirect to='/login' />

}

const mapStateToProps = state => ({
    customerId: state.auth.id,
    isLoggedIn: state.auth.isLoggedIn,
    mfaEnabled: state.auth.mfaEnabled,
    isMfaChecked: state.auth.isMfaChecked,
    brand: state.auth.brand,
})

export default connect(mapStateToProps, { getCustomer, resetVerifiedUser, setRedirectTo})(AuthContainer)



// WEBPACK FOOTER //
// ./resources/js/layout/AuthContainer.js